import { getSavedSearchParams, useSaveFilters } from './use-save-filters';
import { TABLE } from '../const';

interface Return {
  page: number;
  take: number;
  skip: number;
  handlePageChange: (event: React.ChangeEvent<unknown> | null, value: number) => void;
}

const getDefaultFilters = (key: string) => {
  const defaultState = {
    page: 1,
  };

  if (key === 'pagination')
    return {
      ...defaultState,
      ...getSavedSearchParams(defaultState),
    };

  return defaultState;
};

export const usePaginationState = (key?: string): Return => {
  key = key ? `${key}-pagination` : 'pagination';
  const isSaveFilter = key === 'pagination';
  const [{ page }, setPage] = useSaveFilters(key, isSaveFilter, getDefaultFilters(key));

  const handlePageChange = (event: React.ChangeEvent<unknown> | null, value: number) => {
    if (page === value) return;
    setPage({ page: value });
  };

  return {
    page: Number(page),
    take: TABLE.PAGE_MAX_SIZE,
    skip: (Number(page) - 1) * TABLE.PAGE_MAX_SIZE,
    handlePageChange,
  };
};
